import { createSelector } from '@ngrx/store';
import { selectState } from '../../config/selectors';
import { LessonState } from '../reducers/lesson.reducer';

const selectLessonState = createSelector(selectState, (state) => state.lesson);

export const selectLoaded = (id: string) => createSelector(selectLessonState, (state: LessonState) => (state.items[id] ? state.items[id].loaded : null));
export const selectLoading = (id: string) => createSelector(selectLessonState, (state: LessonState) => (state.items[id] ? state.items[id].loading : false));
export const selectLesson = (id: string) => createSelector(selectLessonState, (state: LessonState) => (state.items[id] ? state.items[id].data : null));
